export const isIdpRedirect = (accountInfo) => {
    const isReporting = window.location.href.includes('reporting');
    return ((accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.isSasc) && !isReporting) || ((accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.isIdp) && !(accountInfo === null || accountInfo === void 0 ? void 0 : accountInfo.isSasc) && isReporting);
};
